<template>
  <div>
    <div v-show="!detalhar">
      <FiltroEstabelecimentos 
        @filtrar="buscarEstabelecimentos"
        @datas="datas"
        @quantidade-categorias="categorias"
      />
      <EstabelecimentosTable 
        :loading="loadingEstabelecimentos" 
        :items="estabelecimentos"
        :quantidadeCategorias="quantidadeCategorias"
        @detalhar="detalharEstabelecimento"
      />
    </div>
    <div v-if="detalhar">
      <h2>
        Estabelecimento: {{ estabelecimento.nome_loja }}
        <v-btn 
          flat 
          icon 
          color="primary" 
          v-clipboard="estabelecimento.nome_loja"
        >
          <v-icon>content_copy</v-icon>
        </v-btn>
      </h2>
      <h2>Plano: {{ formatPlano(estabelecimento.plano_estabelecimento) }}</h2>
      <h2>Data de criação: {{ formatData(estabelecimento.created_at) }}</h2>
      <h2>Representante: {{ formatTexto(estabelecimento.representante) }}</h2>
      <h2>Data primeiro pedido: {{ formatData(estabelecimento.primeiro_pedido) }}</h2>
      <h2>Data último pedido: {{ formatData(estabelecimento.ultimo_pedido) }}</h2>
      <h2>Perído: {{ periodo }}</h2>
      <h2>Quantidade de pedidos: {{ estabelecimento.quantidade_pedidos_ok }}</h2>
      <h2>Valor bruto: {{ formatValor(estabelecimento.valor_bruto) }}</h2>
      <h2>Taxa de entrega dos pedidos: {{ formatValor(estabelecimento.taxa_delivery) }}</h2>
      <h2>Valor total do pedidos: {{ formatValor(estabelecimento.valor_liquido) }}</h2>
      <h2>Ticket médio: {{ formatValor(ticketMedio) }}</h2>
      <h2>
        Assinatura: {{ formatAssinatura(estabelecimento.assinatura) }}
        <v-btn
          v-if="estabelecimento.assinatura > 0"
          @click="listaCobrancas"
          color="primary" 
          flat 
          icon>
          <v-icon>launch</v-icon>
        </v-btn>
      </h2>
      <v-btn color="primary" @click="sairPedidos">Voltar para estabelecimentos</v-btn>
      <FiltroPedidos 
        @filtrar="buscarPedidos"
      />
      <PedidosTable 
        :items="pedidos"
        :loading="loadingPedidos"
      />
    </div>
  </div>
</template>

<script>
import api from '../api'
import { formatDate } from '../utils/data'
import EstabelecimentosTable from './EstabelecimentosTable'
import FiltroEstabelecimentos from './FiltroEstabelecimentos'
import PedidosTable from './PedidosTable'
import FiltroPedidos from './FiltroPedidos'

export default {
  name: 'Relatorio',
  components: {
    EstabelecimentosTable,
    FiltroEstabelecimentos,
    PedidosTable,
    FiltroPedidos
  },
  data() {
    return {
      estabelecimentos: [],
      loadingEstabelecimentos: false,
      pedidos: [],
      loadingPedidos: false,
      estabelecimento: null,
      data_inicio: null,
      data_fim: null,
      quantidadeCategorias: 0
    }
  },
  computed: {
    detalhar() {
      return this.estabelecimento !== null
    },
    periodo() {
      let retorno = formatDate(this.data_inicio)
      if (this.data_inicio !== this.data_fim) {
        retorno += ` até ${formatDate(this.data_fim)}`
      }
      return retorno
    },
    ticketMedio() {
      const { quantidade_pedidos_ok, valor_liquido } = this.estabelecimento
      if (quantidade_pedidos_ok > 0) {
        return valor_liquido / quantidade_pedidos_ok
      }
      return 0
    }
  },
  methods: {
    listaCobrancas() {
      window.open(`https://sualoja.pediragora.app/pagamentos/${this.estabelecimento.asaas_id}`)
    },
    formatData(value) {
      return formatDate(value)
    },
    formatTexto(value) {
      if (value === null) {
        return '---'
      }
      return value
    },
    datas(value) {
      const { data_inicio, data_fim } = value
      this.data_inicio = data_inicio
      this.data_fim = data_fim
    },
    categorias(value) {
      this.quantidadeCategorias = value
    },
    formatValor(value) {
      let d = value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      d = d.replace('R$', '').trim()
      return d
    },
    formatAssinatura(value) {
      if (value === undefined) {
        return '...'
      }
      if (value === null) {
        return 'Erro ao buscar valor da assinatura'
      }
      if (value < 0) {
        return 'Cancelado'
      }
      return `R$ ${this.formatValor(value)}`
    },
    formatPlano(value) {
      switch (value) {
        case 0: return 'Prospecção'
        case 1: return 'Livre'
        case 2: return 'Prata'
        case 3: return 'Ouro'
        case 4: return 'Diamante'
        case 5: return 'Safira'
        default: return 'Não especificado'
      }
    },
    detalharEstabelecimento(value) {
      this.estabelecimento = value
      this.buscarAssinatura()
      this.buscarPedidos()
    },
    sairPedidos() {
      this.pedidos = []
      this.estabelecimento = null
    },
    applyFiltro(dados, campo, str = false) {
      const c = dados[campo]
      if (c !== undefined) {
        if (str) {
          return `, ${campo}: "${c}"`
        }
        return `, ${campo}: ${c}`
      }
      return ''
    },
    async buscarEstabelecimentos(value) {
      this.estabelecimentos = []
      try {
        this.loadingEstabelecimentos = true
        const response = await api.post('/', {
          query: `{ estabelecimentos(${value}) { 
              id
              nome_loja
              created_at
              cidade { nome estado }
              status_pagamento
              ultimo_acesso_app 
              versao_app 
              saudacao 
              primeiro_pedido 
              ultimo_pedido 
              quantidade_pedidos_ok
              ticket_medio
              valor_bruto
              taxa_delivery
              valor_liquido
              representante
              plano_estabelecimento
              aberto
              acesso_recente_gerente
              fechado_temporariamente
              agendamento
            } }`
        })
        this.estabelecimentos = response.data.data.estabelecimentos
      }
      catch (e) {
        console.log(e)
        this.estabelecimentos = []
      }
      finally {
        this.loadingEstabelecimentos = false
      }
    },
    async buscarAssinatura() {
      const response = await api.post('/', { 
        query: `{ estabelecimento(id: "${this.estabelecimento.id}") { assinatura asaas_id } }` 
      })
      const { assinatura, asaas_id } = response.data.data.estabelecimento
      this.estabelecimento = {
        ...this.estabelecimento,
        assinatura,
        asaas_id
      }
    },
    async buscarPedidos(value) {
      try {
        this.loadingPedidos = true
        let args = `
          estabelecimento: "${this.estabelecimento.id}", 
          data_inicio: "${this.data_inicio}", 
          data_fim: "${this.data_fim}"
        `
        if (value !== undefined) {
          args += value
        }
        else {
          args += ', status_pedidos: [1, 3, 4]'
        }
        const response = await api.post('/', {
          query: `{ pedidos(${args}) {
            id
            cliente
            aparelho
            status_pedido
            tipo
            com_cupom
            data
            valor_bruto
            taxa_delivery
            valor_liquido
          } }`
        })
        this.pedidos = response.data.data.pedidos
      }
      catch {
        this.pedidos = []
      }
      finally {
        this.loadingPedidos = false
      }
    }
  }
}
</script>
